
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiComCallGoogle as ObiComCallGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-com-call-google.js';
 
 
 

 
 export const ObiComCallGoogle = createComponent({
   react: React,
   tagName: 'obi-com-call-google',
   elementClass: ObiComCallGoogleElement,
   events: {
     
   }
  });
 
 